import Modal from 'LuxKit/Modal/Modal'
import Clickable from 'components/Common/Clickable/Clickable'
import BodyText from 'LuxKit/Typography/BodyText'
import useToggle from 'hooks/useToggle'
import * as React from 'react'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import styled from 'styled-components'
import HelpPane from 'components/Common/HelpPane'
import { FormattedMessage, useIntl } from 'react-intl'

const MiddledTooltipIcon = styled(LineInfoCircleIcon)`
  vertical-align: middle;
`

function OfferPropertyNonRefundablePolicy() {
  const intl = useIntl()
  const [isPolicyOpen, togglePolicy] = useToggle()

  const nonRefundableLabel = intl.formatMessage({
    id: 'k7eJ2gYMxs4TY51FK4hf',
    defaultMessage: 'Non-refundable',
    description: 'Label for non-refundable cancellation policy in the cancellation flow',
  })

  const nonRefundableDetail = intl.formatMessage({
    id: 'APjp0vPEwaRrlUscFjCF',
    defaultMessage: 'Please note that ’Non-Refundable’ packages are guaranteed at the time of booking and not eligible for a refund or date change. Accordingly, please select your package carefully and take note of any cancellation policy applicable to your purchase.',
    description: 'Detailed explanation of non-refundable policy in modal',
  })

  const onClickIcon: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault()
    togglePolicy()
  }

  return (
    <>
      <Clickable onClick={onClickIcon}>
        <BodyText variant="medium" as="span" weight="bold">
          <FormattedMessage
            id="1FUIhDIVdKtlz_hIj8h5"
            defaultMessage="Non-refundable {tooltipIcon}"
            description="Non-refundable cancellation policy label with tooltip icon"
            values={{ tooltipIcon: <MiddledTooltipIcon size="XS" /> }}
          />
        </BodyText>
      </Clickable>
      <Modal
        title={nonRefundableLabel}
        isOpen={isPolicyOpen}
        onClose={togglePolicy}
      >
        <BodyText variant="medium" as="p">{nonRefundableDetail}</BodyText>
        <HelpPane />
      </Modal>
    </>
  )
}

export default OfferPropertyNonRefundablePolicy
